/* eslint-disable no-param-reassign */
import {
  SET_FILTER,
  SET_DEFAULT_FILTERS,
  SET_FILTER_HAS_CHANGED,
  SET_FILTERS_HAS_RESETED,
  SET_TAB_ACTIVE_BY_PAGE,
  SET_PAGINATION_ITEM
} from 'store/actions/filters';
import { setValueObjectByField } from 'helpers/object';
import { FILTERS_BY_DEFAULT } from 'store/enums';

export default {
  [SET_TAB_ACTIVE_BY_PAGE]: (state, { page, value }) => {
    state[page].tabActive = value;
  },

  [SET_FILTER]: (state, { page, filter, value }) => {
    setValueObjectByField(state[page].filters, `${filter}.value`, value);
    state[page].filtersHasChanged = true;
    state[page].filtersHasReseted = false;
  },

  [SET_FILTER_HAS_CHANGED]: (state, { page, value }) => {
    state[page].filtersHasChanged = value;
  },

  [SET_FILTERS_HAS_RESETED]: (state, { page, value }) => {
    state[page].filtersHasReseted = value;
  },

  [SET_DEFAULT_FILTERS]: (state, { page }) => {
    state[page].filters = JSON.parse(JSON.stringify(FILTERS_BY_DEFAULT[page].filters));
    state[page].pagination = JSON.parse(JSON.stringify(FILTERS_BY_DEFAULT[page].pagination));
    state[page].filtersHasReseted = true;
    state[page].filtersHasChanged = false;
  },

  [SET_PAGINATION_ITEM]: (state, { page, item, value }) => {
    setValueObjectByField(state[page].pagination, item, value);
  }
};
